<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-organization-address" class="control-label">{{ inputLabel }}</label>
    <input
      type="text"
      class="form-control organization-address-margin-bottom"
      id="form-organization-address"
      autocomplete="off"
      :disabled="disabled"
      v-model="inputValue"
      @input="emit($event)"
      @change="emit($event)"
      @blur="emit($event)"
    />
    <a v-if="showPrevValue"
      @click="revertAddress"
      class="organization-address-helpers">
      {{ prevValue }}
    </a>
    <typeahead
      target="#form-organization-address"
      :async-function="typeahead"
      :data="typeaheadData"
      @input="selectTypeahead"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      v-model="form.organization.addressData"
      ref="addressRef"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'OrganizationAddressInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Юридический адрес'
    },

    inputName: {
      default: 'address'
    },

    inputHint: {
      default: undefined
    },

    prevValue: {
      default: null
    },

    typeaheadItemKey: {
      type: String,
      default: 'value'
    }
  },

  computed: {
    showPrevValue () {
      return this.prevValue && this.prevValue !== this.inputValue
    }
  },

  methods: {
    revertAddress () {
      this.$emit('input', this.prevValue)
      this.$emit('change', this.prevValue)
    }
  }
}
</script>
